<template>
  <router-view />
</template>

<script>
export default {
    mounted() {
        document.title = this.$config.behavior === 'hilfy' ? 'Hilfy' : 'Profy'
    },
}
</script>
